import { z } from 'zod';
import { maxCharMessage, NotBlankMessage, RequiredMessage } from '../../validation/messages';

const requiredName = z
  .string()
  .min(1, RequiredMessage)
  .max(100, maxCharMessage(100))
  .regex(/^\s*\S[\s\S]*$/, NotBlankMessage)
  .refine((v) => !v.includes('  '), 'Must not contain double spaces');

export const bankAccountBlock = z.object({
  routingTypeId: z.string().min(1, RequiredMessage),
  routingNumber: z.string().min(1, RequiredMessage),
  accountTypeId: z.string().min(1, RequiredMessage),
  accountName: requiredName,
  accountNickName: requiredName,
  institutionName: requiredName,
  accountNumber: z.string().min(1, RequiredMessage),
});

export type BankAccountBlock = z.infer<typeof bankAccountBlock>;
